import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { DictionaryService } from "src/app/dictionary";
import { Animations } from "src/app/_helpers/animations";
import { CompanyService } from "../../company/company.service";
import { InvitationFilter } from "../invitation.model";
import { InvitationService } from "../invitation.service";

@Component({
  selector: "app-invitation-filter-modal",
  templateUrl: "./invitation-filter-modal.component.html",
  styleUrls: ["./invitation-filter-modal.component.scss"],
  animations: [Animations.animeHeight, Animations.animeRotate],
})
export class InvitationFilterModalComponent implements OnInit {
  constructor(
    public companyServ: CompanyService,
    public translate: TranslateService,
    public dictionaryServ: DictionaryService,
    public modalCtrl: ModalController,
    public invitationServ: InvitationService
  ) {}

  showAllInvitations: boolean;

  showCompanies: boolean = false;
  showDevices: boolean = false;
  showDateCriteria: boolean = false;

  filterDetails: InvitationFilter;

  showLoader: boolean;

  startDate: any = new Date();

  @ViewChild('receptionDatePicker') receptionDatePicker


  @Input()
  page: string;

  async ngOnInit() {
    await this.companyServ.loadCompaniesSync("true", true);

  }

  onFilterCompany(event) {
    if (event.detail.value !== "null") {
      this.invitationServ.filterDetails.companyId = event.detail.value;
    } else {
      this.invitationServ.filterDetails.companyId = null;
    }
    this.invitationServ.reloadFilter();
  }

  onFilterDevice(event) {
    if (event.detail.value !== "null") {
      this.invitationServ.filterDetails.deviceId = event.detail.value;
    } else {
      this.invitationServ.filterDetails.deviceId = null;
    }
    this.invitationServ.reloadFilter();
  }

  onDateCriterionChanged(event) {
    this.invitationServ.currentDateCriterion = this.invitationServ.filterDateCriteria.filter(e => e.id === event.detail.value)[0];
    this.invitationServ.reloadFilter(1);
  }


  onFilterDate(date) {
    this.startDate = date;
    this.invitationServ.filterDetails.date = date;

    this.invitationServ.reloadFilter();
  }
  onClearFilters() {
    const today = new Date(Date.now());
    today.setHours(0,0,0,0);
    this.invitationServ.filterDetails = new InvitationFilter();
    this.page !== 'reception' ? document.getElementById('futureRadio').click() :  this.receptionDatePicker.value = new Date();
    this.invitationServ.filterDetails.dateStart = today;
    this.invitationServ.reloadFilter();
  }

  onCloseModal() {
    this.modalCtrl.dismiss();
  }
}
